import * as z from "zod";

const CountryOptionSchema = z
  .object({
    value: z.number().int(),
    label: z.string().min(1, "validation:countryRequired"),
  })
  .optional()
  .nullable();

const CountrySchema = z.object({
  id: z.number().int().nonnegative(),
  name: z.string().min(1, { message: "validation:countryRequired" }),
  iso2: z.string().length(2),
  iso3: z.string().length(3),
  isEu: z.boolean(),
});

export const CountryOptionValidationSchema = CountryOptionSchema;
export type CountryOptionFormInput = z.infer<typeof CountryOptionValidationSchema>;

export const CountryValidationSchema = CountrySchema;
export type CountryFormInput = z.infer<typeof CountryValidationSchema>;
